import { LibraryResponses } from "@tfg/types/endpoints/library"
import {
  OrganizationPermissionLevel,
  OrganizationType,
  OrganizationTypesPermissionLevels,
  OrganizationTypesPermissionLevelsConfig,
} from "@tfg/types/types/organization.types"
import { UserRoles } from "@tfg/types/types/user.types"

export const isPlatformAdmin = (user: LibraryResponses.TFGUser) => {
  return user.role === UserRoles.SUPER_ADMIN
}

export const isSupplier = (user: LibraryResponses.TFGUser) => {
  const organizationPermissionLevel = getOrganizationPermissionLevel(
    user.organization.type
  )
  return (
    organizationPermissionLevel === OrganizationTypesPermissionLevels.SUPPLIER
  )
}
export function getOrganizationPermissionLevel(
  orgType: OrganizationType
): OrganizationPermissionLevel | undefined {
  for (const level of Object.values(OrganizationTypesPermissionLevels)) {
    const types = OrganizationTypesPermissionLevelsConfig[level]
    if (types.includes(orgType)) {
      return level
    }
  }
  return undefined
}
